import React from 'react';
import { Company } from '../../services/api';
import { SendMoneyProvider } from '../../contexts/SendMoneyContext';
import SendMoneyModal from './SendMoneyModal';

interface SendMoneyModalWrapperProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: { receiverCompanyId: string; amount: string }) => void;
  availableCompanies: {company: Company, exchangeRate: number}[];
  currentCompany?: Company;
  isLoading?: boolean;
  // showProcessingModal: boolean;
//   transactionId: string;
//   duration: number;
//   slot: number;
}

const SendMoneyModalWrapper: React.FC<SendMoneyModalWrapperProps> = ({
  isOpen,
  onClose,
  onSubmit,
  availableCompanies,
  currentCompany,
  isLoading = false,
  // showProcessingModal,
//   transactionId,
//   duration,
//   slot,
}) => {
  // Handle external state changes
//   React.useEffect(() => {
//     if (showProcessingModal && transactionId) {
//       // This will be handled by the context when the modal is opened
//     }
//   }, [showProcessingModal, transactionId, duration]);

  return (
    <SendMoneyProvider 
      onSubmit={onSubmit}
      isOpen={isOpen}
      onClose={onClose}
      // showProcessingModal={showProcessingModal}
    //   transactionId={transactionId}
    //   duration={duration}
    //   slot={slot}
    >
      <SendMoneyModal
        availableCompanies={availableCompanies}
        currentCompany={currentCompany}
        isLoading={isLoading}
        onSubmit={onSubmit}
      />
    </SendMoneyProvider>
  );
};

export default SendMoneyModalWrapper;
